import React, {createRef, useEffect, useState} from 'react';
import {Grid} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../constants/ReusableTablePagination';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {useSelector} from 'react-redux';
import PageLoader from '../../../components/PageLoader';

export default function ViewLookUptable({rowData}) {
  const [saveData, setSaveData] = useState([]);
  const {lookupDetailsData} = useSelector(({addLookupMaintenance}) => addLookupMaintenance);
  const {isLoading} = useSelector(({addLookupMaintenance}) => addLookupMaintenance);
  const columns = [
    {
      title: 'Code',
      field: 'valueCode',
    },
    {
      title: 'Value',
      field: 'value',
    },
    // {
    //   title: "From",
    //   field: "effectiveFrom",
    //   render: (rowData) => {
    //     return rowData?.effectiveFrom ? moment(rowData?.effectiveFrom).format("MM/DD/YYYY") : "";
    //   },
    // },
    // {
    //   title: "To",
    //   field: "effectiveTo",
    //   render: (rowData) => {
    //     return rowData?.effectiveTo ? moment(rowData?.effectiveTo).format("MM/DD/YYYY") : "";
    //   },
    // },
  ];
  const tableRef = createRef();

  useEffect(() => {
    if (lookupDetailsData?.length > 0) {
      const data = lookupDetailsData?.map((i) => {
        return {
          ...i,
          effectiveFrom: i?.effectiveFrom,
          effectiveTo: i?.effectiveTo,
          valueCode: i?.valueCode,
          value: i?.value,
        };
      });
      setSaveData(data);
    }
  }, [lookupDetailsData]);
  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon custom-toolbar-icons trigger-table new-standard-textfields px-3">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={saveData}
            tableRef={tableRef}
            textAlign="left"
            options={{
              search: false,
              toolbar: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              paging: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
          />
        </div>
      </Grid>
      {isLoading && <PageLoader />}
    </>
  );
}
